@if(isPageInitialized) {
  <div class="dashboard-top-section d-flex align-items-center justify-content-between">
    <h1>{{ 'serviceLibrary.title' | transloco }}</h1>

    <div class="d-flex gap-2">
      <div class="d-flex align-items-center gap-2">
        <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>
        <div class="header-actions">
          <button class="create-maintenance-button" (click)="openCreateMaintenancePlanModal()">
            <span class="create-maintenance-button-text">{{ 'serviceLibrary.createPlan' | transloco }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="dashboard-widgets">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-connected-service-libraries></app-connected-service-libraries>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-upcoming-maintenance></app-upcoming-maintenance>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-disconnected-units></app-disconnected-units>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-makes></app-makes>
      </div>
    </div>
  </div>

  <div class="bottom-grid-section">
    <div class="bottom-grid-sec-left">
      <div class="service-timelines">
        <div class="service-timelines-header">
          <span class="service-timelines-header-title">
            {{ 'serviceLibrary.serviceTimelines' | transloco }}
          </span>
        </div>

        <div class="service-timelines-body">
          @if(!isLoading) {
            <div class="service-timelines-list">
              @for (schedule of serviceSchedules; track schedule.id) {
                <div class="service-timelines-list-item">
                  <!-- Left Section -->
                  <div class="service-timelines-list-item-left">
                    @if(schedule.logoUrl) {
                      <div class="service-timelines-list-item-logo">
                        <img [src]="schedule.logoUrl" [attr.alt]="'serviceLibrary.logoAlt' | transloco" />
                      </div>
                    }
                    <div class="service-timelines-list-item-title">
                      <div class="service-timelines-list-item-title-row">
                        <span class="service-timelines-list-item-title-row-text">
                          {{ schedule.name }}
                        </span>
                        <span class="service-timelines-list-item-title-row-badge">
                          {{ getScheduleTypeName(schedule.serviceScheduleTypeId) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Right Section -->
                  <div class="service-timelines-list-item-actions">
                    <button type="button" class="service-timelines-list-item-action" (click)="onViewSchedule(schedule)">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 5.25C7.95783 5.25 8.75 6.04275 8.75 7C8.75 7.95783 7.95783 8.75 7 8.75C6.04275 8.75 5.25 7.95783 5.25 7C5.25 6.04275 6.04275 5.25 7 5.25Z" fill="#9FA1A4"/>
                        <path d="M6.99845 2.91797C11.451 2.91797 12.7892 6.77789 12.8014 6.81697L12.8633 7.0013L12.802 7.18564C12.7892 7.22472 11.451 11.0846 6.99845 11.0846C2.54587 11.0846 1.2077 7.22472 1.19545 7.18564L1.13361 7.0013L1.19487 6.81697C1.2077 6.77789 2.54587 2.91797 6.99845 2.91797ZM6.99845 9.91797C10.1199 9.91797 11.3291 7.67447 11.6219 7.0013C11.3279 6.3258 10.1181 4.08464 6.99845 4.08464C3.87703 4.08464 2.66778 6.32814 2.37495 7.0013C2.66895 7.6768 3.87878 9.91797 6.99845 9.91797Z" fill="#9FA1A4"/>
                      </svg>                      
                    </button>
          
                    @if(canDeleteServiceSchedule(schedule.serviceScheduleTypeId)) {
                      <button type="button" class="service-timelines-list-item-action service-timelines-list-item-action--danger" (click)="onDeleteSchedule(schedule)">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.0833 11.668C11.0833 12.3114 10.5601 12.8346 9.91667 12.8346L4.08333 12.8346C3.43992 12.8346 2.91667 12.3114 2.91667 11.668L2.91667 4.66797L1.75 4.66797L1.75 3.5013L3.5 3.5013L4.08333 3.5013L4.08333 2.33464C4.08333 1.69122 4.60658 1.16797 5.25 1.16797L8.75 1.16797C9.39342 1.16797 9.91667 1.69122 9.91667 2.33464L9.91667 3.5013L10.5 3.5013L12.25 3.5013L12.25 4.66797L11.0833 4.66797L11.0833 11.668ZM8.75 2.33464L5.25 2.33464L5.25 3.5013L8.75 3.5013L8.75 2.33464ZM9.33333 4.66797L4.66667 4.66797L4.08333 4.66797L4.08275 11.668L9.91667 11.668L9.91667 4.66797L9.33333 4.66797Z" fill="#9FA1A4"/>
                          <path d="M8.75 5.83203L7.58333 5.83203L7.58333 10.4987L8.75 10.4987L8.75 5.83203ZM6.41667 5.83203L5.25 5.83203L5.25 10.4987L6.41667 10.4987L6.41667 5.83203Z" fill="#9FA1A4"/>
                        </svg>                                              
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="spinner-container d-flex align-items-center justify-content-center spinner-border"></div>
          }
          @if(!isLoading && serviceSchedules.length === 0) {
            <div class="d-flex align-items-center justify-content-center h-100">
              <app-empty-state></app-empty-state>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}